import { Property } from '../types/property';

// TODO: replace with real data from POST /api/brief → GET /api/results/[sessionId]
export const mockProperties: Property[] = [
  {
    id: '1',
    title: 'Charming Victorian Terrace',
    address: '14 Barnsbury Street, Islington',
    postcode: 'N1 1PN',
    price: 875000,
    bedrooms: 3,
    bathrooms: 2,
    propertyType: 'terraced',
    lat: 51.5362,
    lng: -0.1068,
    imageUrl: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400&q=80',
    url: '#',
    matchScore: 92,
    description: 'Beautifully restored Victorian terrace with original features, open-plan kitchen, and a south-facing garden. Moments from Highbury & Islington tube.',
    matchingCriteria: ['3 bedrooms', 'Zone 2', 'Garden', 'Under budget', 'Good primary schools nearby'],
  },
  {
    id: '2',
    title: 'Modern 2-Bed Flat with Balcony',
    address: 'Riverside Quarter, Wandsworth',
    postcode: 'SW18 1TW',
    price: 520000,
    bedrooms: 2,
    bathrooms: 2,
    propertyType: 'flat',
    lat: 51.4567,
    lng: -0.1907,
    imageUrl: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&q=80',
    url: '#',
    matchScore: 85,
    description: 'Bright riverside apartment with floor-to-ceiling windows, concierge, gym, and a private balcony overlooking the Thames.',
    matchingCriteria: ['2 bedrooms', 'River views', 'Gym on site', 'Under budget'],
  },
  {
    id: '3',
    title: 'Spacious Semi-Detached Family Home',
    address: '72 Alleyn Road, Dulwich',
    postcode: 'SE21 8AL',
    price: 1150000,
    bedrooms: 4,
    bathrooms: 3,
    propertyType: 'semi-detached',
    lat: 51.4418,
    lng: -0.0836,
    imageUrl: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400&q=80',
    url: '#',
    matchScore: 78,
    description: 'Generous family home in the heart of Dulwich Village. Large rear garden, loft conversion, and within the Dulwich College catchment area.',
    matchingCriteria: ['4 bedrooms', 'Large garden', 'Top school catchment', 'Quiet neighbourhood'],
  },
  {
    id: '4',
    title: 'Stylish Studio in Shoreditch',
    address: '8 Redchurch Street, Shoreditch',
    postcode: 'E2 7DJ',
    price: 390000,
    bedrooms: 1,
    bathrooms: 1,
    propertyType: 'flat',
    lat: 51.5246,
    lng: -0.0729,
    imageUrl: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&q=80',
    url: '#',
    matchScore: 70,
    description: 'Architect-designed studio in the creative heart of East London. Exposed brick, polished concrete floors, and seconds from Old Street roundabout.',
    matchingCriteria: ['Zone 1', 'Near tech hubs', 'Under budget'],
  },
  {
    id: '5',
    title: 'Detached House with Garden',
    address: '3 Elm Park Gardens, Chelsea',
    postcode: 'SW10 9QF',
    price: 2400000,
    bedrooms: 5,
    bathrooms: 4,
    propertyType: 'detached',
    lat: 51.4855,
    lng: -0.1739,
    imageUrl: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&q=80',
    url: '#',
    matchScore: 61,
    description: 'Exceptional detached residence on a sought-after Chelsea garden square. Grand reception rooms, wine cellar, and private garage.',
    matchingCriteria: ['5 bedrooms', 'Prime location', 'Private garage'],
  },
  {
    id: '6',
    title: 'Period Conversion Flat',
    address: '55 Dartmouth Park Hill, Tufnell Park',
    postcode: 'N19 5HN',
    price: 625000,
    bedrooms: 2,
    bathrooms: 1,
    propertyType: 'flat',
    lat: 51.5603,
    lng: -0.1387,
    imageUrl: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=400&q=80',
    url: '#',
    matchScore: 88,
    description: 'Upper-floor flat in an Edwardian conversion with high ceilings, bay windows, and a private terrace. A short walk to Hampstead Heath.',
    matchingCriteria: ['2 bedrooms', 'Near green space', 'Period features', 'Under budget', 'Quiet street'],
  },
];
